// open print dialog using hidden iframe
function printPage (url, params) {
	if (params) {
		url = url.concat('?', buildQueryString(params));
	}

	var oHiddFrame = document.createElement("iframe");
	oHiddFrame.onload = setPrint;
	oHiddFrame.style.position = "fixed";
	oHiddFrame.style.right = "0";
	oHiddFrame.style.bottom = "0";
	oHiddFrame.style.width = "0";
	oHiddFrame.style.height = "0";
	oHiddFrame.style.border = "0";
	oHiddFrame.src = url;
	document.body.appendChild(oHiddFrame);
}

function buildQueryString(params) {
	var str = [];
	for (var param in params)
		if (params.hasOwnProperty(param)) {
			str.push(encodeURIComponent(param) + "=" + encodeURIComponent(params[param]));
		}
	return str.join("&");
}

function closePrint () {
	document.body.removeChild(this.__print_container__);
}

function setPrint () {
	this.contentWindow.__print_container__ = this;
	this.contentWindow.onbeforeunload = closePrint;
	this.contentWindow.onafterprint = closePrint;
	this.contentWindow.focus(); // Required for IE
	this.contentWindow.print();
}

export {
	printPage
}
